<template>
    <v-card>
        <Toolbar
            :showDrawer="false"
            @backEmit="reset"
            :toolbarTitle="toolbarText"
            :tooltipMessage="$t('Auf dieser Seite haben Sie Überblick auf Themen')"
            :lastPath="!(showAdd || showDelete) ? { name: 'forums' } : null"
        />
        <v-container fluid>
            <v-row no-gutters>
                <v-col :cols="12">
                    <keep-alive>
                        <component
                            :is="isComponent"
                            :type="type"
                            @create="handleCreate"
                            @update="handleUpdate"
                            @delete="handleDelete"
                            :permissions="editorPermissions"
                            @input="reset"
                        />
                    </keep-alive>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>
<script>
import ForumMixin from '../../Components/Forum/Mixins/ForumMixin';

import Toolbar from '../../Components/Generic/Toolbar';
import ThreadList from '../../Components/Forum/ThreadList';
import AddUpdateThread from '../../Components/Forum/AddUpdateThread';
import DeleteThread from '../../Components/Forum/DeleteThread';

export default {
    name: 'threads',
    components: { ThreadList, Toolbar, AddUpdateThread, DeleteThread },
    mixins: [ForumMixin],
    data: () => ({
        showAdd: false,
        type: 'ADD',
        showDelete: false,
        editorPermissions: {
            add: false,
            update: false,
            delete: false,
            move: false,
            copy: false,
            details: false,
            groups: false
        }
    }),
    computed: {
        isSelected() {
            return Object.keys(this.getSelectedThread).length > 0;
        },
        isComponent() {
            if (this.showAdd) {
                return AddUpdateThread;
            }
            if (this.showDelete) {
                return DeleteThread;
            }
            return ThreadList;
        },
        toolbarText() {
            if (this.showAdd) {
                switch (this.type) {
                    case 'ADD':
                        return this.$t('Thema erstellen');
                    case 'UPDATE':
                        return this.$t('Thema bearbeiten');
                }
            }
            return this.$t('Themen');
        }
    },
    methods: {
        reset() {
            this.showAdd = false;
            this.showDelete = false;
        },
        handleDelete() {
            this.showDelete = true;
        },
        handleCreate() {
            this.type = 'ADD';
            this.showAdd = true;
        },
        handleUpdate() {
            this.type = 'UPDATE';
            this.showAdd = true;
        }
    },
    mounted() {
        const onlyAdminsCanPost = this.getSelectedForum.onlyAdminsCanPost
            ? this.getLoggedInAdmin.role === 'ADMIN' || this.getLoggedInAdmin.role === 'SUPER_ADMIN'
            : true;
        const permissions = {
            add: ['FORUM_MANAGEMENT', onlyAdminsCanPost],
            update: ['FORUM_MANAGEMENT', onlyAdminsCanPost],
            delete: ['FORUM_MANAGEMENT', onlyAdminsCanPost],
            move: false,
            copy: false,
            details: false,
            groups: false
        };
        this.validateEditorState(permissions).then((result) => {
            this.editorPermissions = result;
        });
    }
};
</script>
